import Component from '../vendor/Component'

export default class BAOAccordionGroup extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this.selectors = {
      trigger: '[data-bao-accordion-group-el="trigger"]',
      content: '[data-bao-accordion-group-el="content"]'
    }

    this.triggerEl = this._elem.querySelector(this.selectors.trigger)
    this.contentEl = this._elem.querySelector(this.selectors.content)
  }

  async mount() {
    this.setupListeners()

    this.handleDefaultOpen()
  }

  setupListeners ()  {
    this.triggerEl.addEventListener('click', this.handleTrigger.bind(this))

    // listens to product Description Read More 
    this._elem.addEventListener('product:readMoreToggle', this.handleContentResize.bind(this))
  }

  handleContentResize() {
    // Only recalculate if accordion is open
    if (!this.currentState) return

    // Wait for DOM paint so height is correct
    requestAnimationFrame(() => {
      this._elem.style.setProperty('--Max_Height', `${this.contentEl.scrollHeight}px`)
    })
  }

  handleTrigger (event) {
    this._elem.style.setProperty('--Max_Height', `${this.contentEl.scrollHeight}px`)
    this._elem.setAttribute('aria-expanded', !this.currentState)

    this.handleTracking(event.currentTarget)
  }

  handleDefaultOpen () {
    if (!this.currentState) return

    this._elem.style.setProperty('--Max_Height', `${this.contentEl.scrollHeight}px`)
  }

  handleTracking (trigger) {
    const accordionGroup = this._elem.getAttribute('data-gtm-target-context')

    if (!accordionGroup) return

    const triggerText = trigger.innerText || ''

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: `${accordionGroup.replaceAll('-', '_')}_trigger_click`,
      target_text: triggerText,
      event_action: this.currentState ? 'open' : 'close'
    });
  }

  get currentState () {
    return this._elem.getAttribute('aria-expanded') === 'true'
  }
}
